import Vue from 'vue'
import { mapState } from 'vuex'

import { getAnnouncements } from '@/api/announcement'
import { contractContents, getContent, getContents } from '@/api/content'
import { corpMixins } from '@/mixins/corp-mixins'

interface Data {
  planInfo: boolean
  contents: model.Content[]
}

export default Vue.extend({
  mixins: [corpMixins],
  name: 'ContractPlan',
  data(): Data {
    return {
      planInfo: false,
      contents: []
    }
  },

  created() {
    this.getContractPlan()
  },

  computed: {
    ...mapState(['loading', 'user']),
    checkExpirationDate(): boolean {
      const plantsDate = new Date(this.user.corp_contract.current_period_end)
      const currentDate: any = Date.now()
      return plantsDate > currentDate
    }
  },

  methods: {
    async getContractPlan() {
      Promise.all([getAnnouncements(),contractContents()])
        .then(([aRes, cRes]) => {
          this.$store.dispatch('loading', false)
          this.contents = cRes.data
        })
        .catch(() => {
          this.$store.dispatch('loading', false)
        })
    },
    contentDetail(contentId: any) {
      this.$router.push({ path: `/contents/${ contentId }` })
    }
  }
})
